import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { PendientesCargaDescarga as Comp } from "app/features/componentes/cargas";
export interface Props {
    /**Id de la carga/descarga */
    idCargaDescarga: number;
}

/**Dado el idCargaDescarga muestra los sobres y paquetes pendientesk */
export class PendientesCargaDescarga extends React.PureComponent<Props> {
    idCargaDescarga = (props: Props) => props.idCargaDescarga;
    pendientes = createSelectorRx(this.idCargaDescarga, idCargaDescarga => observeResource(resources.CargaDescarga.ObtenerServiciosPendientes, idCargaDescarga));

    onQuitarPaquete = async ( x: models.PaquetePendienteDto) => {
        const idCargaDescarga = this.props.idCargaDescarga;
        await resources.CargaDescarga.QuitarServicioIncompleto(idCargaDescarga, x.IdServicio, x.NumeroFisico, models.TipoFolioFisico.Paquete);
    }

    onQuitarSobre = async (x:models.SobrePendienteDto) => {
        const idCargaDescarga = this.props.idCargaDescarga;
        await resources.CargaDescarga.QuitarServicioIncompleto(idCargaDescarga, x.IdServicio, x.NumeroFisico, models.TipoFolioFisico.Sobre);
    }

    render() {
        const val = this.pendientes(this.props);
        return <Comp 
            value={val} 
            onQuitarPaquete={this.onQuitarPaquete}
            onQuitarSobre={this.onQuitarSobre}
        />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/edit/estatus/items/pendientes/index.tsx